var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 95.4672,
    height: 95.4672,
    rx: 23,
    fill: "#7CC1E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1326 24V27.7348C35.9091 27.7348 26 37.644 26 49.8674C26 62.0821 35.9178 72 48.1326 72C58.7807 72 67.6727 64.4799 69.787 54.4612C70.02 53.3362 69.7348 52.1678 69.0098 51.2775C68.2847 50.3873 67.198 49.8709 66.0504 49.8709C66 49.8692 65.9513 49.8692 65.9026 49.8692C64.0961 49.8692 62.5381 51.1332 62.1643 52.9015C60.7751 59.3732 55.0215 64.2243 48.1343 64.2243C40.2126 64.2243 33.7792 57.7926 33.7792 49.8692C33.7792 41.9404 40.2056 35.514 48.1343 35.514V39.115L58.7859 31.5584L48.1326 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6719 53.9518C39.0388 53.6597 39.2057 53.5258 39.1744 53.5467C40.2333 52.6721 41.0662 51.954 41.6765 51.3924C42.2868 50.8308 42.8015 50.2431 43.224 49.6276C43.6448 49.012 43.8551 48.4122 43.8551 47.8297C43.8551 47.3863 43.7526 47.042 43.5474 46.7934C43.3422 46.5447 43.0344 46.4213 42.6241 46.4213C42.2138 46.4213 41.8921 46.576 41.6608 46.8838C41.4278 47.1916 41.3131 47.6263 41.3131 48.1879H38.6406C38.6615 47.2698 38.8597 46.503 39.2318 45.8875C39.6039 45.272 40.096 44.8182 40.7063 44.5261C41.3166 44.2339 41.9947 44.0879 42.7389 44.0879C44.0238 44.0879 44.994 44.4165 45.6461 45.0755C46.2998 45.7345 46.6267 46.5934 46.6267 47.6506C46.6267 48.8069 46.232 49.8779 45.4444 50.8655C44.6567 51.8532 43.6517 52.8182 42.4311 53.7571H46.8041V56.0088H38.6719V53.9518Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.084 54.0648V51.8287L53.2029 44.5068H56.2961V51.667H57.6245V54.0648H56.2961V56.1704H53.5263V54.0648H48.084ZM53.721 47.5531L50.9999 51.667H53.721V47.5531Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerServiceIcon);
export default __webpack_public_path__ + "static/media/customer-service-icon.2696e00ef9f3b57fd8ab9fdc010757c9.svg";
export { ForwardRef as ReactComponent };